/**
 *
 * @author Matthew Rawson @ 19/02/2018 11:56
 * @description
 * @notes
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import {TextArea} from "@irati/ui/src/FormItem"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {formatDriverName} from "@irati/insights/utils/string"

import DriverButton from "./DriverButton"
import {DRIVER_BUTTON_SIZE} from "./driver.constants"
import SentimentList from "./Sentiment/SentimentList"

const Wrapper = styled.div`
  padding-bottom: 100px;
`

const CommentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 20px 0;
  align-items: flex-start;
  button {
    margin-top: ${({theme}) => theme.spacing.one};
  }

  > * {
    flex: 0;
    width: 100%;
    margin: 0;
    ${({hasOnlyOneDriver}) => (hasOnlyOneDriver) && `
      margin: 0 0 0 -15px;
  `}
  }

  textarea {
    resize: none;
    width: 100%;
    position: relative;
    height: ${DRIVER_BUTTON_SIZE}px;
  }

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    flex-direction: row;

    > * {
      flex: 1;
      min-height: ${DRIVER_BUTTON_SIZE}px;
    }

    textarea {
      margin-left: ${theme.spacing.one};
    }
  `}
`

const DriverWrapper = styled.div`
  margin-bottom: 15px;

  ${minWidthMedia.tablet`
    margin-bottom: 0;
    display: flex;
    flex: 0 0 ${DRIVER_BUTTON_SIZE}px;
  `}
`

const MAX_CHARACTERS = 5000

class DriverComment extends Component {
  static propTypes = {
    onBack: PropTypes.func,
    onChange: PropTypes.func,
    formatMessage: PropTypes.func.isRequired,
    comment: PropTypes.shape({
      text: PropTypes.string,
      driver: PropTypes.object
    }).isRequired,
    hasOnlyOneDriver: PropTypes.bool
  };
  static defaultProps = {
    selectedDriver: {},
    onBack: () => {
    },
    onChange: () => {
    },
    hasOnlyOneDriver: false
  };


  constructor(props) {
    super(props)
    this.state = {}
    this.initFocus = false
  }


  render() {
    const idNamespace = id("DriverComment", this.props)
    const {comment, onBack, onChange, formatMessage, hasOnlyOneDriver} = this.props
    return (
      <Wrapper id={idNamespace}>
        <CommentWrapper hasOnlyOneDriver={hasOnlyOneDriver}>
          {!hasOnlyOneDriver && <DriverWrapper>
            <DriverButton
              id={idNamespace}
              driver={comment.driver}
              onClick={onBack}
              showBackArrow>
              {formatDriverName(formatMessage, comment.driver)}
            </DriverButton>
          </DriverWrapper>}
          <TextArea
            id={id("comment-area", idNamespace)}
            inputRef={(ref) => {
              if (ref && !this.initFocus) {
                this.initFocus = true
                ref.focus()
              }
            }}
            name="driverComment"
            placeholder={formatMessage({id: "insights.userSurvey.driverComment.placeHolder"})}
            label="Driver comment"
            value={comment.text}
            maxLength={MAX_CHARACTERS}
            onChange={onChange}
            hideLabel />
        </CommentWrapper>

        <SentimentList id={idNamespace} driver={comment.driver} />

      </Wrapper>
    )
  }
}

export default injectIntl(DriverComment)
